import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  List,
  ListItem,
  Divider
} from 'react95';

import Github from '../files/github.png';
import Linkedin from '../files/linkedin.png'

import {
  Link,
} from "react-router-dom";

import Clock from '../components/Menu/Clock';

export default {
  title: 'AppBar',
  component: AppBar,
  decorators: [
    story => (
      <div
        style={{
          padding: '5rem',
          background: 'teal'
        }}
      >
        {story()}
      </div>
    )
  ]
};

export const Menu = () => {
  const [open, setOpen] = useState(false);

  return (
    <AppBar style={{ top: 'auto', bottom: 0 }}>
      <Toolbar>
          <Button
            onClick={() => setOpen(!open)}
            active={open}
            style={{ fontWeight: 'bold' }}
          >
            Start
          </Button>
          {open && (
            <List
              style={{
                position: 'absolute',
                left: '0',
                bottom: '30px'
              }}
              onClick={() => setOpen(false)}
            >

              <Link to="/">
                <ListItem >
                  About
                  </ListItem>
              </Link>
              <Link to="/contact">
                <ListItem >
                  Contact
                  </ListItem>
              </Link>


              <Link to="/docs">
                <ListItem >
                  Docs

              </ListItem>
              </Link>

              <Link to="/projects">
                <ListItem >
                  Projects
                  </ListItem>
              </Link>

              <Divider />
              <ListItem disabled>
                <span role='img' aria-label='🔙'>
                  🔙
                </span>
                Logout
              </ListItem>
            </List>
          )}
           <a href="https://github.com/Paranoidal97" target="_blank">
          <Button style={{marginLeft:"10px", marginRight:"10px", height:"35px" , bottom:"0px !important"}}>
            <img src={Github} style={{ width: 'auto', height: '20px', display: 'block' }}
            />
          </Button>
          </a>
          <a href="https://www.linkedin.com/in/%C5%82ukasz-rams-b2396b125/" target="_blank">
          <Button style={{height:"35px", bottom:"0px"}}>
            <img src={Linkedin} style={{ width: 'auto', height: '20px', display: 'block' }}
            />
          </Button>
          </a>
        <Clock />
      </Toolbar>
    </AppBar>
  );
};

Menu.story = {
  name: 'default'
};